"use client";

import HeroProvinceBar from "@/components/HeroProvinceBar";

export default function HeroSection() {
  return (
    <section className="hero-ochre" aria-labelledby="home-hero-title">
      {/* Optional: add a light hero background image to stabilize LCP */}
      {/* <Image src="/hero.webp" alt="" fill priority fetchPriority="high" sizes="100vw" className="object-cover opacity-60" /> */}
      <div className="hero-ochre-inner">
        <div className="hero-ochre-content">
          <h1 id="home-hero-title" className="hero-ochre-title">
            Sagre oggi e nel weekend: scopri quelle vicino a te!
          </h1>
          <p className="hero-ochre-subtitle">
            Cerca sagre vicino a te o per provincia, aggiornate quotidianamente.
          </p>
          <div className="hero-ochre-actions">
            <HeroProvinceBar placeholder="Vicino a me" ctaLabel="CERCA" />
          </div>
        </div>
      </div>
    </section>
  );
}
